<template>
  <div>
    <div>
      <div style="padding-bottom: 5px;">
        <el-button size="mini" @click="searchUser">搜索</el-button>
      </div>
      <el-descriptions size="mini" :column="2" border>
        <el-descriptions-item label="所属组织">
          <el-select style="width: 300px;" v-model="data.organization_project_id" @change="projectaid" size="mini" filterable clearable placeholder="项目">
            <el-option
              v-for="item in projecta"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="房间">
          <el-select style="width: 300px;" v-model="data.room" size="mini" :remote-method="remoteRoom" clearable filterable remote reserve-keyword  placeholder="房间号">
            <el-option
              v-for="item in room"
              :key="item.room"
              :label="item.room"
              :value="item.room">
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="客户名称">
          <el-input style="width: 300px;" size="mini" v-model="data.name" placeholder="客户名称"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="客户性质">
          <el-checkbox-group style="width: 300px;" size="mini" v-model="data.type">
            <el-checkbox label="个人客户" name="type"></el-checkbox>
            <el-checkbox label="企业客户" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
        <el-descriptions-item label="客户类型">
          <el-checkbox-group size="mini" v-model="data.user_type" >
            <el-checkbox label="业主" name="type"></el-checkbox>
            <el-checkbox label="租户" name="type"></el-checkbox>
            <el-checkbox label="住户" name="type"></el-checkbox>
            <el-checkbox label="共用人" name="type"></el-checkbox>
            <el-checkbox label="开发商" name="type"></el-checkbox>
            <el-checkbox label="其它" name="type"></el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
      </el-descriptions>


      <div style="margin-top: 10px;">
        <div style="color:red;">当前选择：<span v-if="user.id">姓名：{{user.name}} , 身份证：{{user.credentials_code}}</span></div>
        <el-table :data="tableData" height="400" border style="width: 100%;" size="mini" cell-click="dade">
<!--            <el-table-column prop="community_name" label="项目" width="180"></el-table-column>-->
          <el-table-column prop="id" label="ID" width="90" fixed></el-table-column>
            <el-table-column prop="name" label="姓名" width="120" fixed>
              <template slot-scope="scope">
                <el-link type="primary" @click="showEditor(scope.row.id)">{{scope.row.name}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="credentials_code" label="身份证" min-width="180"></el-table-column>
          <el-table-column prop="organization_name" label="归属组织" width="180"></el-table-column>
            <el-table-column prop="address" label="房产" width="340"></el-table-column>
          <el-table-column prop="operator" label="上次更新人" width="120"></el-table-column>
            <el-table-column width="100" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click="userAdd(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
      </div>
    </div>
    <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" :append_to_body="true" @callback="editorCallback" />
  </div>
</template>

<script>
  import Editor from "../Customer/editor";
  export default {
    components: {Editor},
    // 接受父组件的值
      props: {
        house: String,
        required: true
      },
      watch:{
        "house"(vel){
          if(vel){
            this.data.room = vel;
            this.searchUser();
          }
        }
      },
      data () {
        return {
          tableData:[],
          data_user:{
            id:'',
            name:'',
            credentials_code:'',
            organization_project_id:'',
            house_id:'',
          },
          id:11,
          data:{
            id:'',
            organization_project_id:'',
            room:'',
            house_id:'',
            name:'',
            type:[],
            user_type:[],
          },
          user:[],
          projecta:[],
          room:[],
          editor:{
            classValue:1,
            id:0,
            visable:false
          },
        }
      },
      mounted(){
          //名下项目
          this.$myhttp.get('admin/common/pindex',{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
              this.projecta = backdata.data.data;
          });
      },
      //事件
      methods: {
        //选择项目
        projectaid(){
          this.data.room = '';
          //this.data.name = '';
          this.user = [];
          this.room = [];
        },
        //搜索客户
        remoteMethod(query) {
          this.data.name = query;
          this.$myhttp.post('admin/RoomSetUpUser/username',this.data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.user = backdata.data.data;
          });
        },
        //搜索房间
        remoteRoom(query){
          this.data.room = query;
          this.$myhttp.post('admin/RoomSetUpUser/room',this.data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.room = backdata.data.data;
          });
        },
        searchUser(){
          console.log(this.data);
          this.$myhttp.post('admin/RoomSetUpUser/name',this.data,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              this.tableData = backdata.data.data;
          });
        },
        dade(e){
          //console.log(e);
        },
        userAdd(item){
          this.user = item;
        },
        //返回数据
        getUser(){
          return this.user;
        },

        showEditor(customer_id) {
          const that=this;
          that.getCustomerBase(customer_id,data=>{
            that.editor.classValue = data.class
            that.editor.id = customer_id
            that.editor.visable = true
          })
        },
        getCustomerBase(customer_id,callback){
          ERP.getRequest({
            url: "admin/Customer/getCustomerBase",
            data: {
              id: customer_id,
            }
          }, res => {
            if (res.code) {
              typeof callback ==="function"&&callback(res.data);
            }
          })
        },
        editorCallback(arg) {
          // this.getList()
          if(arg && arg[0]) this.editor.id = arg[0]
        },
      }
    }
</script>

<style scoped>
  @import '../../../assets/css/table.css';
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/room-user.vue